export const delay = (timer: number) =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve(null)
    }, timer)
  })
